const i18nConfig =
  {
        // Overriding English properties
    'en': {
      'needhelp': "Password Recovery",
      'primaryauth.submit': 'Log In',
      'password.forgot.email.or.username.placeholder': 'Username',
      'password.forgot.email.or.username.tooltip': 'Username'
    },
    'es': {
      'primaryauth.title': 'Iniciar sesión',
      'primaryauth.username.placeholder': 'Nombre de usuario',
      'mfa.challenge.password.placeholder': 'Contraseña',
      'oform.next': 'Siguiente',
      'unlockaccount': '¿Desbloquear cuenta?',
      'help': 'Ayuda',
      'password.reset.title.generic': 'Restablecer contraseña',
      'password.complexity.requirements.header': 'Requisitos de contraseña: ',
      'password.complexity.length.description': 'Debe contener al menos {0} caracteres',
      'password.complexity.lowercase.description': 'Debe contener al menos una letra minúscula',
      'password.complexity.uppercase.description': 'Debe contener al menos una letra mayúscula',
      'password.complexity.number.description': 'Debe contener al menos un número',
      'password.complexity.symbol.description': 'Debe contener al menos un carácter especial',
      'password.complexity.no_username.description': 'No debe contener parte del nombre de usuario',
      'password.complexity.no_first_name.description': 'No debe contener parte de su nombre',
      'password.complexity.no_last_name.description': 'No debe contener parte de su apellido',
      'password.complexity.history.description': 'La contraseña no puede ser la misma que su última contraseña',
      'oie.password.newPasswordLabel': 'Nueva contraseña',
      'oie.password.confirmPasswordLabel': 'Repita la nueva contraseña',
      'password.reset.revokeSessions': 'Cierra mi sesión en todos los demás dispositivos.',
      'password.reset': 'Restablecer contraseña',
      'goback': 'Regresar a Iniciar sesión',
      'idx.return.link.otponly.your.verification.code': 'Su código de verificación',
      'idx.enter.otp.in.original.tab': 'Ingrese la OTP en su ubicación de autenticación original.',
      'idx.return.link.otponly.warning.text': 'Si no solicitó este código, puede ignorar este mensaje. Su cuenta es segura y solo se puede acceder a ella con este código.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': '¡Cuenta desbloqueada exitosamente! Verifique su cuenta con un método de seguridad para continuar',
      'oie.password.challenge.title': 'Verifique con su contraseña',
      'oie.password.label': 'Contraseña',
      'mfa.challenge.verify': 'verificar',
      'forgotpassword': 'Ha olvidado su contraseña',
      'oie.email.challenge.mfa.title': 'Obtenga  un correo electrónico de verificación',
      'oie.email.verify.subtitle.text.without.email': 'Envíe un correo electrónico de verificación haciendo clic en "Envíame un correo electrónico".',
      'oie.email.verify.primaryButton': 'Envíame un correo electrónico',
      'oie.email.mfa.title': 'Verifique con su correo electrónico',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'Enviamos un correo electrónico a <$1>{0}</$1>.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Ingrese el código de verificación en el cuadro de texto.',
      'mfa.challenge.enterCode.placeholder': 'Introducir código',
      'oie.select.authenticators.verify.title': 'Verifique que es usted con un método de seguridad',
      'oie.select.authenticators.verify.subtitle': 'Seleccione entre las siguientes opciones',
      'oie.email.label': 'Correo electrónico',
      'oie.verify.authenticator.button.text': 'Seleccionar',
      'oie.phone.label': 'Teléfono',
      'oie.phone.verify.sms.sendText.without.phone': 'Enviar un código vía SMS a su teléfono',
      'oie.phone.carrier.charges': 'Es posible que se apliquen cargos por mensajería del operador',
      'oie.phone.sms.primaryButton': 'Recibir un código vía SMS',
      'oie.phone.call.secondaryButton': 'Recibir una llamada de voz en su lugar',
      'oie.verification.switch.authenticator': 'Verificar con otra cosa',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Le enviamos un correo electrónico de verificación.',
      'oie.email.verify.alternate.instructions': 'Haga clic en el enlace de verificación en su correo electrónico para continuar o ingrese el código a continuación.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Introducir un código de verificación en su lugar',
      'oie.phone.verify.mfa.calling.without.phone': 'Llamando a su teléfono. Ingrese el código a continuación para verificar.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Se envió un código a su teléfono. Ingrese el código a continuación para verificar.',
      'oie.password.reset.verification': 'Verifique con uno de los siguientes métodos de seguridad para restablecer su contraseña.',
      'oie.phone.verify.title': 'Verifique con su teléfono',
      'oie.phone.verify.sms.sendText': 'Enviar un código vía SMS a',
      'oie.phone.alternate.title': 'su teléfono',
      'mfa.calling': 'llamando',
      'oie.phone.verify.enterCodeText': 'Ingrese el código a continuación para verificar.',
      'oie.phone.verify.sms.codeSentText': 'Se envió un código a'
    },
    'pt-BR': {
      'primaryauth.title': 'Acessar',
      'primaryauth.username.placeholder': 'Nome de usuário',
      'mfa.challenge.password.placeholder': 'Senha',
      'oform.next': 'Próxima',
      'unlockaccount': 'Desbloquear conta?',
      'help': 'Ajuda',
      'password.reset.title.generic': 'Redefinir a senha',
      'password.complexity.requirements.header': 'Requisitos de senha: ',
      'password.complexity.length.description': 'Deve conter pelo menos {0} caracteres',
      'password.complexity.lowercase.description': 'Deve conter pelo menos uma letra minúscula',
      'password.complexity.uppercase.description': 'Deve conter pelo menos uma letra maiúscula',
      'password.complexity.number.description': 'Deve conter pelo menos um número',
      'password.complexity.symbol.description': 'Deve conter pelo menos um símbolo',
      'password.complexity.no_username.description': 'Não deve conter parte do nome de usuário',
      'password.complexity.no_first_name.description': 'Não deve conter parte do seu primeiro nome',
      'password.complexity.no_last_name.description': 'Não deve conter parte do seu sobrenome',
      'password.complexity.history.description': 'A senha não pode ser igual à sua última senha',
      'oie.password.newPasswordLabel': 'Nova senha',
      'oie.password.confirmPasswordLabel': 'Repita a nova senha',
      'password.reset.revokeSessions': 'Desconecte-me de todos os outros dispositivos.',
      'password.reset': 'Redefinir senha',
      'goback': 'Voltar para Iniciar sessão',
      'idx.return.link.otponly.your.verification.code': 'Seu código de verificação',
      'idx.enter.otp.in.original.tab': 'Insira o OTP em seu local de autenticação original.',
      'idx.return.link.otponly.warning.text': 'Se você não solicitou este código, pode ignorar esta mensagem. Sua conta está segura e só pode ser acessada com este código.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Conta desbloqueada com sucesso! Verifique sua conta com um método de segurança para continuar.',
      'oie.password.challenge.title': 'Verifique com sua senha',
      'oie.password.label': 'Senha',
      'mfa.challenge.verify': 'verificar',
      'forgotpassword': 'Esqueceu sua senha',
      'oie.email.challenge.mfa.title': 'Receba um e-mail de verificação',
      'oie.email.verify.subtitle.text.without.email': 'Envie um e-mail de verificação clicando em "Envie-me um e-mail".',
      'oie.email.verify.primaryButton': 'Envie-me um e-mail',
      'oie.email.mfa.title': 'Verifique com seu e-mail',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'Enviamos um e-mail para <$1>{0}</$1>.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Insira o código de verificação na caixa de texto.',
      'mfa.challenge.enterCode.placeholder': 'Insira o código',
      'oie.select.authenticators.verify.title': 'Verifique sua identidade com um método de segurança',
      'oie.select.authenticators.verify.subtitle': 'Selecione uma das seguintes opções',
      'oie.email.label': 'Email',
      'oie.verify.authenticator.button.text': 'Selecione',
      'oie.phone.label': 'Telefone',
      'oie.phone.verify.sms.sendText.without.phone': 'Envie um código via SMS para o seu telefone',
      'oie.phone.carrier.charges': 'Taxas de mensagens da operadora podem ser aplicadas',
      'oie.phone.sms.primaryButton': 'Receba um código por SMS',
      'oie.phone.call.secondaryButton': 'Receba uma chamada de voz',
      'oie.verification.switch.authenticator': 'Verifique por outro meio',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Enviamos a você um e-mail de verificação.',
      'oie.email.verify.alternate.instructions': 'Clique no link de verificação em seu e-mail para continuar ou digite o código abaixo.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Insira um código de verificação',
      'oie.phone.verify.mfa.calling.without.phone': 'Ligando para o seu telefone. Digite o código abaixo para verificar.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Um código foi enviado para o seu telefone. Digite o código abaixo para verificar.',
      'oie.password.reset.verification': 'Verifique com um dos seguintes métodos de segurança para redefinir sua senha.',
      'oie.phone.verify.title': 'Verifique com seu telefone',
      'oie.phone.verify.sms.sendText': 'Envie um código via SMS para',
      'oie.phone.alternate.title': 'seu telefone',
      'mfa.calling': 'ligando',
      'oie.phone.verify.enterCodeText': 'Digite o código abaixo para verificar.',
      'oie.phone.verify.sms.codeSentText': 'Um código foi enviado para'
    },
    'pl': {
      'primaryauth.title': 'Zaloguj się',
      'primaryauth.username.placeholder': 'Nazwa użytkownika',
      'mfa.challenge.password.placeholder': 'Hasło',
      'oform.next': 'Przejdź dalej',
      'unlockaccount': 'Odblokować konto?',
      'help': 'Pomoc',
      'password.reset.title.generic': 'Zresetuj swoje hasło',
      'password.complexity.requirements.header': 'Wymagania dotyczące hasła: ',
      'password.complexity.length.description': 'Powinno zawierać co najmniej {0} znaków',
      'password.complexity.lowercase.description': 'Powinno zawierać co najmniej jedną małą literę',
      'password.complexity.uppercase.description': 'Powinno zawierać co najmniej jedną wielką literę',
      'password.complexity.number.description': 'Powinno zawierać co najmniej jedną cyfrę',
      'password.complexity.symbol.description': 'Powinno zawierać co najmniej jeden znak specjalny',
      'password.complexity.no_username.description': 'Nie powinno zawierać części nazwy użytkownika',
      'password.complexity.no_first_name.description': 'Nie powinno zawierać Twojego imienia',
      'password.complexity.no_last_name.description': 'Nie powinno zawierać Twojego nazwiska',
      'password.complexity.history.description': 'Nowe hasło nie powinno być takie samo jak poprzednie',
      'oie.password.newPasswordLabel': 'Nowe hasło',
      'oie.password.confirmPasswordLabel': 'Powtórz nowe hasło',
      'password.reset.revokeSessions': 'Wyloguj mnie ze wszystkich innych urządzeń.',
      'password.reset': 'Zresetuj hasło',
      'goback': 'Powrót do logowania',
      'idx.return.link.otponly.your.verification.code': 'Twój kod weryfikacyjny',
      'idx.enter.otp.in.original.tab': 'Wprowadź hasło jednorazowe w oryginalnej lokalizacji uwierzytelniania.',
      'idx.return.link.otponly.warning.text': 'Jeśli to nie Ty prosiłeś o ten kod, zignoruj tę wiadomość. Twoje konto jest bezpieczne i można uzyskać do niego dostęp wyłącznie za pomocą tego kodu.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Konto odblokowano pomyślnie! Aby kontynuować, zweryfikuj swoje konto za pomocą metody zabezpieczającej.',
      'oie.password.challenge.title': 'Zweryfikuj za pomocą hasła',
      'oie.password.label': 'Hasło',
      'mfa.challenge.verify': 'Weryfikacja',
      'forgotpassword': 'Zapomniałem hasła',
      'oie.email.challenge.mfa.title': 'Uzyskaj e-mail weryfikacyjny',
      'oie.email.verify.subtitle.text.without.email': 'Wyślij e-mail weryfikacyjny, klikając "Wyślij mi e-mail".',
      'oie.email.verify.primaryButton': 'Wyślij mi e-mail',
      'oie.email.mfa.title': 'Zweryfikuj za pomocą swojego adresu e-mail',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'Wysłaliśmy e-mail na adres <$1>{0}</$1>.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Wpisz kod weryfikacyjny w polu tekstowym.',
      'mfa.challenge.enterCode.placeholder': 'Wprowadź kod',
      'oie.select.authenticators.verify.title': 'Potwierdź, że to Ty, korzystając z metody zabezpieczającej',
      'oie.select.authenticators.verify.subtitle': 'Wybierz jedną z poniższych opcji',
      'oie.email.label': 'Email',
      'oie.verify.authenticator.button.text': 'Wybierz',
      'oie.phone.label': 'Telefon',
      'oie.phone.verify.sms.sendText.without.phone': 'Wyślij kod SMS-em na swój telefon',
      'oie.phone.carrier.charges': 'Operator może naliczyć opłaty za przesyłanie wiadomości',
      'oie.phone.sms.primaryButton': 'Odbierz kod SMS-em',
      'oie.phone.call.secondaryButton': 'Zamiast tego odbierz połączenie głosowe',
      'oie.verification.switch.authenticator': 'Sprawdź, używając innej opcji',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Wysłaliśmy do Ciebie e-mail weryfikacyjny.',
      'oie.email.verify.alternate.instructions': 'Kliknij link weryfikacyjny w wiadomości e-mail, aby kontynuować, lub wprowadź poniższy kod.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Zamiast tego wpisz kod weryfikacyjny',
      'oie.phone.verify.mfa.calling.without.phone': 'Połączenie telefoniczne. Wpisz poniższy kod w celu weryfikacji.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Kod został wysłany na Twój telefon. Wpisz poniższy kod w celu weryfikacji.',
      'oie.password.reset.verification': 'Aby zresetować hasło, zweryfikuj je, korzystając z jednej z poniższych metod zabezpieczeń.',
      'oie.phone.verify.title': 'Zweryfikuj za pomocą telefonu',
      'oie.phone.verify.sms.sendText': 'Wyślij kod SMS-em na ',
      'oie.phone.alternate.title': 'Twój telefon',
      'mfa.calling': 'połączenie telefoniczne ',
      'oie.phone.verify.enterCodeText': 'Wpisz poniższy kod w celu weryfikacji.',
      'oie.phone.verify.sms.codeSentText': 'Kod został wysłany do'
    },
    'hu': {
      'primaryauth.title': 'Bejelentkezés',
      'primaryauth.username.placeholder': 'Felhasználónév',
      'mfa.challenge.password.placeholder': 'Jelszó',
      'oform.next': 'Következő',
      'unlockaccount': 'Feloldja a fiók zárolását?',
      'help': 'Súgó',
      'password.reset.title.generic': 'Jelszó visszaállítása',
      'password.complexity.requirements.header': 'Jelszókövetelmények: ',
      'password.complexity.length.description': 'Tartalmazzon legalább {0} karaktert',
      'password.complexity.lowercase.description': 'Tartalmazzon legalább egy kisbetűt',
      'password.complexity.uppercase.description': 'Tartalmazzon legalább egy nagybetűt',
      'password.complexity.number.description': 'Tartalmazzon legalább egy számot ',
      'password.complexity.symbol.description': 'Tartalmazzon legalább egy különleges karaktert',
      'password.complexity.no_username.description': 'Nem tartalmazhatja a felhasználónév részeit',
      'password.complexity.no_first_name.description': 'Nem tartalmazhatja az Ön utónevét',
      'password.complexity.no_last_name.description': 'Nem tartalmazhatja az Ön vezetéknevét',
      'password.complexity.history.description': 'A jelszó nem egyezhet meg a legutóbbi jelszóval',
      'oie.password.newPasswordLabel': 'Új jelszó',
      'oie.password.confirmPasswordLabel': 'Jelszó megerősítése',
      'password.reset.revokeSessions': 'Jelentkeztessenek ki az összes többi eszközről.',
      'password.reset': 'Jelszó visszaállítása',
      'goback': 'Vissza a bejelentkezéshez',
      'idx.return.link.otponly.your.verification.code': 'Az Ön igazoló kódja',
      'idx.enter.otp.in.original.tab': 'Adja meg az egyszer használatos jelszót az eredeti hitelesítési helyen.',
      'idx.return.link.otponly.warning.text': 'Ha nem Ön kérte ezt a kódot, figyelmen kívül hagyhatja ezt az üzenetet. Fiókja biztonságban van, és csak ezzel a kóddal érhető el.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'A fiók zárolása sikeresen feloldva! A folytatáshoz igazolja fiókját egy biztonsági módszerrel.',
      'oie.password.challenge.title': 'Igazolás jelszóval',
      'oie.password.label': 'Jelszó',
      'mfa.challenge.verify': 'igazolás',
      'forgotpassword': 'Elfelejtett jelszó',
      'oie.email.challenge.mfa.title': 'Igazoló e-mail kérése',
      'oie.email.verify.subtitle.text.without.email': 'Igazoló e-mailt az „E-mailt kérek” lehetőségre kattintva igényelhet.',
      'oie.email.verify.primaryButton': 'E-mailt kérek',
      'oie.email.mfa.title': 'Igazolás e-mail-címmel',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'E-mailt küldtünk a következő címre: <$1>{0}</$1>.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Írja be az igazoló kódot a szövegmezőbe.',
      'mfa.challenge.enterCode.placeholder': 'Kód beírása',
      'oie.select.authenticators.verify.title': 'Igazolja személyazonosságát egy biztonsági módszerrel',
      'oie.select.authenticators.verify.subtitle': 'Válasszon a következő lehetőségek közül',
      'oie.email.label': 'E-mail',
      'oie.verify.authenticator.button.text': 'Kiválasztás',
      'oie.phone.label': 'Telefon',
      'oie.phone.verify.sms.sendText.without.phone': 'Kód kérése SMS-ben a telefonjára',
      'oie.phone.carrier.charges': 'A szolgáltató üzenetküldési díjai lehetnek érvényben',
      'oie.phone.sms.primaryButton': 'SMS-ben kérek kódot',
      'oie.phone.call.secondaryButton': 'Inkább hanghívást kérek',
      'oie.verification.switch.authenticator': 'Igazolás más módszerrel',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Igazoló e-mailt küldtünk Önnek.',
      'oie.email.verify.alternate.instructions': 'Kattintson az e-mailben található igazoló linkre a folytatáshoz, vagy írja be az alábbi kódot.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Inkább igazoló kódot adok meg',
      'oie.phone.verify.mfa.calling.without.phone': 'Tárcsázzuk a telefonszámát. Az igazoláshoz írja be az alábbi kódot.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Kódot küldtünk a telefonjára. Az igazoláshoz írja be az alábbi kódot.',
      'oie.password.reset.verification': 'Jelszava visszaállításához igazolás szükséges az alábbi biztonsági módszerek egyikével.',
      'oie.phone.verify.title': 'Igazolás telefonon',
      'oie.phone.verify.sms.sendText': 'Kódot kérek SMS-ben a',
      'oie.phone.alternate.title': 'telefonomra',
      'mfa.calling': 'hívás',
      'oie.phone.verify.enterCodeText': 'Az igazoláshoz írja be az alábbi kódot.',
      'oie.phone.verify.sms.codeSentText': 'Kódot küldtünk ide: '
    },
    'it': {
      'primaryauth.title': 'Registrazione',
      'primaryauth.username.placeholder': 'Nome utente',
      'mfa.challenge.password.placeholder': 'Password',
      'oform.next': 'Prossima',
      'unlockaccount': "Sbloccare l'account?",
      'help': 'Aiuto',
      'password.reset.title.generic': 'Reimposta la password',
      'password.complexity.requirements.header': 'Requisiti della password: ',
      'password.complexity.length.description': 'Deve contenere almeno {0} caratteri',
      'password.complexity.lowercase.description': 'Deve contenere almeno una lettera minuscola',
      'password.complexity.uppercase.description': 'Deve contenere almeno una lettera maiuscola',
      'password.complexity.number.description': 'Deve contenere almeno un numero',
      'password.complexity.symbol.description': 'Deve contenere almeno un simbolo',
      'password.complexity.no_username.description': 'Non deve contenere parti del nome utente',
      'password.complexity.no_first_name.description': 'Non deve contenere il tuo nome',
      'password.complexity.no_last_name.description': 'Non deve contenere il tuo cognome',
      'password.complexity.history.description': "La password non può uguale all'ultima",
      'oie.password.newPasswordLabel': 'Nuova password',
      'oie.password.confirmPasswordLabel': 'Ripeti la password',
      'password.reset.revokeSessions': 'Disconnettimi da tutti gli altri dispositivi.',
      'password.reset': 'Resetta la password',
      'goback': 'Torna a Registrazione',
      'idx.return.link.otponly.your.verification.code': 'Il tuo codice di verifica',
      'idx.enter.otp.in.original.tab': "Inserisci l'OTP nella posizione di autenticazione originale.",
      'idx.return.link.otponly.warning.text': 'Se non hai richiesto questo codice, puoi ignorare questo messaggio. Il tuo account è sicuro e puoi accedervi solo con questo codice.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Account sbloccato correttamente! Per continuare, verifica il tuo account con un metodo di sicurezza.',
      'oie.password.challenge.title': 'Verifica con la tua password',
      'oie.password.label': 'Password',
      'mfa.challenge.verify': 'verifica',
      'forgotpassword': 'Password dimenticata',
      'oie.email.challenge.mfa.title': "Ricevi un'e-mail di verifica",
      'oie.email.verify.subtitle.text.without.email': "Invia un'e-mail di verifica facendo clic su 'Inviami un'e-mail'.",
      'oie.email.verify.primaryButton': "Inviami un'e-mail",
      'oie.email.mfa.title': 'Verifica con la tua e-mail',
      'oie.email.verify.alternate.magicLinkToEmailAddress': "Abbiamo inviato un'e-mail a <$1>{0}</$1>.",
      'oie.email.verify.alternate.verificationCode.instructions': 'Inserisci il codice di verifica nella casella di testo.',
      'mfa.challenge.enterCode.placeholder': 'Inserisci il codice',
      'oie.select.authenticators.verify.title': 'Verifica la tua identità con un metodo di sicurezza',
      'oie.select.authenticators.verify.subtitle': 'Seleziona tra le seguenti opzioni',
      'oie.email.label': 'E-mail',
      'oie.verify.authenticator.button.text': 'Seleziona',
      'oie.phone.label': 'Telefono',
      'oie.phone.verify.sms.sendText.without.phone': 'Invia un codice via SMS al tuo telefono',
      'oie.phone.carrier.charges': "Potrebbero essere applicate tariffe per messaggistica previste dall'operatore",
      'oie.phone.sms.primaryButton': 'Ricevi un codice tramite SMS',
      'oie.phone.call.secondaryButton': 'In alternativa, ricevi una chiamata vocale',
      'oie.verification.switch.authenticator': 'Verifica con altro strumento',
      'oie.email.verify.alternate.magicLinkToYourEmail': "Ti abbiamo inviato un'e-mail di verifica.",
      'oie.email.verify.alternate.instructions': 'Per continuare fai clic sul collegamento di verifica nella tua e-mail o inserisci il codice seguente.',
      'oie.email.verify.alternate.show.verificationCode.text': 'In alternativa, inserisci un codice di verifica',
      'oie.phone.verify.mfa.calling.without.phone': 'Stai per ricevere una chiamata. Per verificare inserisci il codice qui sotto.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Abbiamo inviato un codice al tuo telefono. Per verificare inserisci il codice qui sotto.',
      'oie.password.reset.verification': 'Per reimpostare la password verifica con uno dei seguenti metodi di sicurezza.',
      'oie.phone.verify.title': 'Verifica con il tuo telefono',
      'oie.phone.verify.sms.sendText': 'Invia un codice via SMS a',
      'oie.phone.alternate.title': 'il tuo telefono',
      'mfa.calling': 'chiamando',
      'oie.phone.verify.enterCodeText': 'Per verificare inserisci il codice qui sotto.',
      'oie.phone.verify.sms.codeSentText': 'È stato inviato un codice a'
    },
    'ro': {
      'primaryauth.title': 'Conectare',
      'primaryauth.username.placeholder': 'Nume de utilizator',
      'mfa.challenge.password.placeholder': 'Parolă',
      'oform.next': 'Înainte',
      'unlockaccount': 'Deblocați contul?',
      'help': 'Ajutor',
      'password.reset.title.generic': 'Parola a fost resetată!',
      'password.complexity.requirements.header': 'Cerințe privind parola: ',
      'password.complexity.length.description': 'Cel puțin {0} caractere',
      'password.complexity.lowercase.description': 'Cel puțin o literă mică',
      'password.complexity.uppercase.description': 'Cel puțin o literă mare',
      'password.complexity.number.description': 'Cel puțin un număr',
      'password.complexity.symbol.description': 'Cel puțin un caracter special',
      'password.complexity.no_username.description': 'Nicio parte din numele de utilizator',
      'password.complexity.no_first_name.description': 'Nicio parte din prenumele dumneavoastră',
      'password.complexity.no_last_name.description': 'Nicio parte din numele dumneavoastră',
      'password.complexity.history.description': 'Parola nu poate fi aceeași cu ultima dumneavoastră parolă',
      'oie.password.newPasswordLabel': 'Parolă nouă',
      'oie.password.confirmPasswordLabel': 'Confirmare parolă',
      'password.reset.revokeSessions': 'Deconectați-mă de la toate celelalte dispozitive.',
      'password.reset': 'Resetare parolă',
      'goback': 'Înapoi la Conectare',
      'idx.return.link.otponly.your.verification.code': 'Codul de verificare',
      'idx.enter.otp.in.original.tab': 'Introduceți OTP în locația originală de autentificare.',
      'idx.return.link.otponly.warning.text': 'Dacă nu ați solicitat acest cod, puteți ignora acest mesaj. Contul dumneavoastră este în siguranță și poate fi accesat numai cu acest cod.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Contul a fost deblocat cu succes! Verificați-vă contul cu o metodă de securitate pentru a continua.',
      'oie.password.challenge.title': 'Verificați cu parola dumneavoastră',
      'oie.password.label': 'Parolă',
      'mfa.challenge.verify': 'verificare',
      'forgotpassword': 'Parolă uitată',
      'oie.email.challenge.mfa.title': 'Primiți un e-mail de verificare',
      'oie.email.verify.subtitle.text.without.email': 'Trimiteți un e-mail de verificare făcând clic pe „Trimitere e-mail”.',
      'oie.email.verify.primaryButton': 'Trimitere e-mail',
      'oie.email.mfa.title': 'Verificați cu e-mailul dumneavoastră',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'Am trimis un e-mail la <$1>{0}</$1>.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Introduceți codul de verificare în caseta de text.',
      'mfa.challenge.enterCode.placeholder': 'Introducere cod',
      'oie.select.authenticators.verify.title': 'Verificați-vă identitatea cu o metodă de securitate',
      'oie.select.authenticators.verify.subtitle': 'Selectați dintre următoarele opțiuni',
      'oie.email.label': 'E-mail',
      'oie.verify.authenticator.button.text': 'Selectare',
      'oie.phone.label': 'Telefon',
      'oie.phone.verify.sms.sendText.without.phone': 'Trimiteți un cod prin SMS la numărul dumneavoastră de telefon',
      'oie.phone.carrier.charges': 'Se pot aplica taxe de mesaje de la operator',
      'oie.phone.sms.primaryButton': 'Primiți un cod prin SMS',
      'oie.phone.call.secondaryButton': 'În schimb, primiți un apel vocal',
      'oie.verification.switch.authenticator': 'Verificați cu altă metodă',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'V-am trimis un e-mail de verificare.',
      'oie.email.verify.alternate.instructions': 'Faceți clic pe linkul de verificare din e-mail pentru a continua sau introduceți codul mai jos.',
      'oie.email.verify.alternate.show.verificationCode.text': 'În schimb, introduceți un cod de verificare',
      'oie.phone.verify.mfa.calling.without.phone': 'Vă apelăm. Introduceți codul mai jos pentru a verifica.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'A fost trimis un cod la numărul dumneavoastră de telefon. Introduceți codul mai jos pentru a verifica.',
      'oie.password.reset.verification': 'Verificați cu una dintre următoarele metode de securitate pentru a vă reseta parola.',
      'oie.phone.verify.title': 'Verificați cu numărul de telefon',
      'oie.phone.verify.sms.sendText': 'Trimiteți un cod prin SMS la',
      'oie.phone.alternate.title': 'numărul de telefon',
      'mfa.calling': 'apelare în curs',
      'oie.phone.verify.enterCodeText': 'Introduceți codul de mai jos pentru a verifica.',
      'oie.phone.verify.sms.codeSentText': 'A fost trimis un cod către'
    },
    'de': {
      'primaryauth.title': 'Anmelden',
      'primaryauth.username.placeholder': 'Benutzername',
      'mfa.challenge.password.placeholder': 'Passwort',
      'oform.next': 'Nächste',
      'unlockaccount': 'Konto entsperren?',
      'help': 'Hilfe',
      'password.reset.title.generic': 'Passwort zurücksetzen',
      'password.complexity.requirements.header': 'Passwortanforderungen: ',
      'password.complexity.length.description': 'Sollte mindestens {0} Zeichen enthalten',
      'password.complexity.lowercase.description': 'Sollte mindestens einen Kleinbuchstaben enthalten',
      'password.complexity.uppercase.description': 'Sollte mindestens einen Großbuchstaben enthalten',
      'password.complexity.number.description': 'Sollte mindestens eine Nummer enthalten',
      'password.complexity.symbol.description': 'Sollte mindestens ein Sonderzeichen enthalten',
      'password.complexity.no_username.description': 'Sollte keinen Teil des Benutzernamens enthalten',
      'password.complexity.no_first_name.description': 'Sollte keinen Teil Ihres Vornamens enthalten',
      'password.complexity.no_last_name.description': 'Sollte keinen Teil Ihres Nachnamens enthalten',
      'password.complexity.history.description': 'Das Passwort darf nicht mit Ihrem letzten Passwort identisch sein.',
      'oie.password.newPasswordLabel': 'Neues Passwort',
      'oie.password.confirmPasswordLabel': 'Neues Passwort wiederholen',
      'password.reset.revokeSessions': 'Melden Sie mich von allen anderen Geräten ab.',
      'password.reset': 'Passwort zurücksetzen',
      'goback': 'Zurück zur Anmeldung',
      'idx.return.link.otponly.your.verification.code': 'Ihr Bestätigungscode',
      'idx.enter.otp.in.original.tab': 'Geben Sie das Einmalpasswort an Ihrem ursprünglichen Authentifizierungsort ein.',
      'idx.return.link.otponly.warning.text': 'Wenn Sie diesen Code nicht angefordert haben, können Sie diese Nachricht ignorieren. Ihr Konto ist sicher und kann nur mit diesem Code aufgerufen werden.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Konto erfolgreich entsperrt! Verifizieren Sie Ihr Konto mit einer Sicherheitsmethode, um fortzufahren.',
      'oie.password.challenge.title': 'Mit Ihrem Passwort verifizieren',
      'oie.password.label': 'Passwort',
      'mfa.challenge.verify': 'verifizieren',
      'forgotpassword': 'Passwort vergessen',
      'oie.email.challenge.mfa.title': 'Verifizierungs-E-Mail erhalten',
      'oie.email.verify.subtitle.text.without.email': 'Senden Sie eine Verifizierungs-E-Mail, indem Sie auf „Schicken Sie mir eine E-Mail“ klicken.',
      'oie.email.verify.primaryButton': 'Schicken Sie mir eine E-Mail',
      'oie.email.mfa.title': 'Mit Ihrer E-Mail verifizieren',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'Wir haben eine E-Mail an <$1>{0}</$1> gesendet.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Geben Sie den Verifizierungscode in das Textfeld ein.',
      'mfa.challenge.enterCode.placeholder': 'Code eingeben',
      'oie.select.authenticators.verify.title': 'Bestätigen Sie Ihre Identität mit einer Sicherheitsmethode',
      'oie.select.authenticators.verify.subtitle': 'Wählen Sie aus den folgenden Optionen',
      'oie.email.label': 'E-Mail',
      'oie.verify.authenticator.button.text': 'Auswählen',
      'oie.phone.label': 'Telefon',
      'oie.phone.verify.sms.sendText.without.phone': 'Senden Sie einen Code per SMS an Ihr Telefon',
      'oie.phone.carrier.charges': 'Es fallen ggf. Nachrichtengebühren des Netzbetreibers an.',
      'oie.phone.sms.primaryButton': 'Erhalten Sie einen Code per SMS',
      'oie.phone.call.secondaryButton': 'Erhalten Sie stattdessen einen Sprachanruf',
      'oie.verification.switch.authenticator': 'Mit etwas anderem verifizieren',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Wir haben Ihnen eine Verifizierungs-E-Mail gesendet.',
      'oie.email.verify.alternate.instructions': 'Klicken Sie auf den Verifizierungslink in Ihrer E-Mail, um fortzufahren, oder geben Sie den Code unten ein.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Geben Sie stattdessen einen Verifizierungscode ein',
      'oie.phone.verify.mfa.calling.without.phone': 'Sie erhalten einen Anruf. Geben Sie zur Verifizierung den untenstehenden Code ein.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Ein Code wurde an Ihr Telefon gesendet. Geben Sie zur Verifizierung den untenstehenden Code ein.',
      'oie.password.reset.verification': 'Verifizieren Sie sich mit einer der folgenden Sicherheitsmethoden, um Ihr Passwort zurückzusetzen.',
      'oie.phone.verify.title': 'Mit Ihrem Telefon verifizieren',
      'oie.phone.verify.sms.sendText': 'Senden Sie einen Code per SMS an',
      'oie.phone.alternate.title': 'Ihr Telefon',
      'mfa.calling': 'Anruf',
      'oie.phone.verify.enterCodeText': 'Geben Sie zur Verifizierung den untenstehenden Code ein.',
      'oie.phone.verify.sms.codeSentText': 'Ein Code wurde gesendet an'
    },
    'nl-NL': {
      'primaryauth.title': 'Inloggen',
      'primaryauth.username.placeholder': 'Gebruikersnaam',
      'mfa.challenge.password.placeholder': 'Wachtwoord',
      'oform.next': 'Volgende',
      'unlockaccount': 'Account ontgrendelen?',
      'help': 'Hulp',
      'password.reset.title.generic': 'Wachtwoord opnieuw instellen',
      'password.complexity.requirements.header': 'Wachtwoordvereisten: ',
      'password.complexity.length.description': 'Ten minste {0} tekens',
      'password.complexity.lowercase.description': 'Eén kleine letter',
      'password.complexity.uppercase.description': 'Eén hoofdletter',
      'password.complexity.number.description': 'Eén cijfer',
      'password.complexity.symbol.description': 'Eén speciaal teken',
      'password.complexity.no_username.description': 'Geen deel van uw gebruikersnaam',
      'password.complexity.no_first_name.description': 'Mag geen deel van uw voornaam bevatten',
      'password.complexity.no_last_name.description': 'Mag geen deel van uw achternaam bevatten',
      'password.complexity.history.description': 'Wachtwoord mag niet hetzelfde zijn als uw laatste wachtwoord',
      'oie.password.newPasswordLabel': 'Nieuw wachtwoord',
      'oie.password.confirmPasswordLabel': 'Herhaal nieuw wachtwoord',
      'password.reset.revokeSessions': 'Meld mij af bij alle andere apparaten.',
      'password.reset': 'Wachtwoord opnieuw instellen',
      'goback': 'Terug naar inloggen',
      'idx.return.link.otponly.your.verification.code': 'Uw verificatiecode',
      'idx.enter.otp.in.original.tab': 'Voer het eenmalige wachtwoord (OTP) in op uw oorspronkelijke authenticatielocatie.',
      'idx.return.link.otponly.warning.text': 'Als u deze code niet hebt aangevraagd, kunt u dit bericht negeren. Uw account is veilig en kan alleen worden geopend met deze code.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Account succesvol ontgrendeld! Verifieer uw account met een beveiligingsmethode om verder te gaan.',
      'oie.password.challenge.title': 'Verifiëren met uw wachtwoord',
      'oie.password.label': 'Wachtwoord',
      'mfa.challenge.verify': 'verifiëren',
      'forgotpassword': 'Wachtwoord vergeten',
      'oie.email.challenge.mfa.title': 'Ontvang een verificatie-e-mail',
      'oie.email.verify.subtitle.text.without.email': 'Stuur een verificatie-e-mail door op "Stuur mij een e-mail" te klikken.',
      'oie.email.verify.primaryButton': 'Stuur mij een e-mail',
      'oie.email.mfa.title': 'Verifieer met uw e-mail',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'We hebben een e-mail gestuurd naar <$1>{0}</$1>.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Voer de verificatiecode in het tekstvak in.',
      'mfa.challenge.enterCode.placeholder': 'Voer code in',
      'oie.select.authenticators.verify.title': 'Verifieer dat u het bent met een beveiligingsmethode',
      'oie.select.authenticators.verify.subtitle': 'Selecteer uit de volgende opties',
      'oie.email.label': 'E-mail',
      'oie.verify.authenticator.button.text': 'Selecteer',
      'oie.phone.label': 'Telefoon',
      'oie.phone.verify.sms.sendText.without.phone': 'Stuur een code via sms naar je telefoon',
      'oie.phone.carrier.charges': 'Er kunnen kosten in rekening worden gebracht voor berichten van de provider',
      'oie.phone.sms.primaryButton': 'Ontvang een code via SMS',
      'oie.phone.call.secondaryButton': 'Ontvang in plaats daarvan een spraakoproep',
      'oie.verification.switch.authenticator': 'Verifiëren met iets anders',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Wij hebben u een verificatie-e-mail gestuurd.',
      'oie.email.verify.alternate.instructions': 'Klik op de verificatielink in uw e-mail om door te gaan of voer de onderstaande code in.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Voer in plaats daarvan een verificatiecode in',
      'oie.phone.verify.mfa.calling.without.phone': 'Je telefoon bellen. Voer de onderstaande code in om te verifiëren.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Er is een code naar uw telefoon verzonden. Voer de onderstaande code in om te verifiëren.',
      'oie.password.reset.verification': 'Verifieer met een van de volgende beveiligingsmethoden om uw wachtwoord opnieuw in te stellen.',
      'oie.phone.verify.title': 'Verifieer met uw telefoon',
      'oie.phone.verify.sms.sendText': 'Stuur een code via sms naar',
      'oie.phone.alternate.title': 'uw telefoon',
      'mfa.calling': 'belt',
      'oie.phone.verify.enterCodeText': 'Voer de onderstaande code in om te verifiëren.',
      'oie.phone.verify.sms.codeSentText': 'Er is een code verzonden naar'
    },
    'fr': {
      'primaryauth.title': 'Se connecter',
      'primaryauth.username.placeholder': "Nom d'utilisateur",
      'mfa.challenge.password.placeholder': 'Mot de passe',
      'oform.next': 'Suivant',
      'unlockaccount': 'Débloquez le compte ?',
      'help': 'Aide',
      'password.reset.title.generic': 'Réinitialisez votre mot de passe',
      'password.complexity.requirements.header': 'Exigences relatives au mot de passe : ',
      'password.complexity.length.description': 'Doit contenir au moins {0} caractères',
      'password.complexity.lowercase.description': 'Doit contenir au moins une lettre minuscule',
      'password.complexity.uppercase.description': 'Doit contenir au moins une lettre majuscule',
      'password.complexity.number.description': 'Doit contenir au moins un chiffre',
      'password.complexity.symbol.description': 'Doit contenir au moins un caractère spécial',
      'password.complexity.no_username.description': "Ne doit pas contenir une partie du nom d'utilisateur",
      'password.complexity.no_first_name.description': 'Ne doit pas contenir une partie de votre prénom',
      'password.complexity.no_last_name.description': 'Ne doit pas contenir une partie de votre nom de famille',
      'password.complexity.history.description': 'Le mot de passe ne peut pas être le même que votre dernier mot de passe',
      'oie.password.newPasswordLabel': 'Nouveau mot de passe',
      'oie.password.confirmPasswordLabel': 'Répétez le nouveau mot de passe',
      'password.reset.revokeSessions': 'Déconnectez-moi de tous les autres appareils.',
      'password.reset': 'Réinitialisez le mot de passe ',
      'goback': "Retour à l'identification",
      'idx.return.link.otponly.your.verification.code': 'Votre code de vérification',
      'idx.enter.otp.in.original.tab': 'Saisissez l’OTP dans votre emplacement d’authentification d’origine.',
      'idx.return.link.otponly.warning.text': "Si vous n'avez pas demandé ce code, vous pouvez ignorer ce message. Votre compte est sécurisé et vous ne pouvez y accéder qu'avec ce code.",
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Compte débloqué avec succès ! Vérifiez votre compte avec une méthode de sécurité pour continuer.',
      'oie.password.challenge.title': 'Vérifiez avec votre mot de passe',
      'oie.password.label': 'Mot de passe',
      'mfa.challenge.verify': 'Vérifiez',
      'forgotpassword': 'Mot de passe oublié',
      'oie.email.challenge.mfa.title': 'Recevez un e-mail de vérification',
      'oie.email.verify.subtitle.text.without.email': 'Envoyez un email de vérification en cliquant sur "Envoyez-moi un email".',
      'oie.email.verify.primaryButton': 'Envoyez-moi un email',
      'oie.email.mfa.title': 'Vérifiez avec votre email',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'Nous avons envoyé un e-mail à <$1>{0}</$1>.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Saisissez le code de vérification dans la zone de texte.',
      'mfa.challenge.enterCode.placeholder': 'Saisissez le code',
      'oie.select.authenticators.verify.title': "Vérifiez qu'il s'agit bien de vous avec une méthode de sécurité",
      'oie.select.authenticators.verify.subtitle': 'Sélectionnez parmi les options suivantes',
      'oie.email.label': 'Email',
      'oie.verify.authenticator.button.text': 'Sélectionnez  ',
      'oie.phone.label': 'Téléphone',
      'oie.phone.verify.sms.sendText.without.phone': 'Envoyez un code par SMS sur votre téléphone',
      'oie.phone.carrier.charges': "Des frais de messagerie de l'opérateur peuvent s'appliquer",
      'oie.phone.sms.primaryButton': 'Recevez un code par SMS',
      'oie.phone.call.secondaryButton': 'Recevez plutôt un appel vocal',
      'oie.verification.switch.authenticator': 'Vérifiez avec autre chose',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Nous vous avons envoyé un e-mail de vérification.',
      'oie.email.verify.alternate.instructions': 'Cliquez sur le lien de vérification dans votre e-mail pour continuer ou saisissez le code ci-dessous.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Saisissez plutôt un code de vérification',
      'oie.phone.verify.mfa.calling.without.phone': 'Appelez votre téléphone. Saisissez le code ci-dessous pour vérifier.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Un code a été envoyé sur votre téléphone. Saisissez le code ci-dessous pour vérifier.',
      'oie.password.reset.verification': "Vérifiez avec l'une des méthodes de sécurité suivantes pour réinitialiser votre mot de passe.",
      'oie.phone.verify.title': 'Vérifiez avec votre téléphone',
      'oie.phone.verify.sms.sendText': 'Envoyez un code par SMS à',
      'oie.phone.alternate.title': 'votre téléphone',
      'mfa.calling': 'appel',
      'oie.phone.verify.enterCodeText': 'Saisissez le code ci-dessous pour vérifier.',
      'oie.phone.verify.sms.codeSentText': 'Un code a été envoyé à'
    },
    'ru': {
      'primaryauth.title': 'Войти',
      'primaryauth.username.placeholder': 'Имя пользователя',
      'mfa.challenge.password.placeholder': 'Пароль',
      'oform.next': 'Далее',
      'unlockaccount': 'Разблокировать аккаунт?',
      'help': 'Справка',
      'password.reset.title.generic': 'Сброс пароля',
      'password.complexity.requirements.header': 'Требования к паролю: ',
      'password.complexity.length.description': 'Не менее {0} символов',
      'password.complexity.lowercase.description': 'Строчная буква',
      'password.complexity.uppercase.description': 'Заглавная буква',
      'password.complexity.number.description': 'Число',
      'password.complexity.symbol.description': 'Символ',
      'password.complexity.no_username.description': 'Не должен содержать часть имени пользователя',
      'password.complexity.no_first_name.description': 'Не должен содержать часть вашего имени',
      'password.complexity.no_last_name.description': 'Не должен содержать часть вашей фамилии',
      'password.complexity.history.description': 'Пароль не может совпадать с вашим последним паролем.',
      'oie.password.newPasswordLabel': 'Новый пароль',
      'oie.password.confirmPasswordLabel': 'Введите пароль ещё раз',
      'password.reset.revokeSessions': 'Выйти из системы на всех других устройствах.',
      'password.reset': 'Сбросить пароль',
      'goback': 'Вернуться на страницу входа',
      'idx.return.link.otponly.your.verification.code': 'Ваш код подтверждения',
      'idx.enter.otp.in.original.tab': 'Введите одноразовый пароль в исходном месте аутентификации.',
      'idx.return.link.otponly.warning.text': 'Если вы не запрашивали этот код, проигнорируйте это сообщение. Ваш аккаунт в безопасности, доступ к нему возможен только с этим кодом.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Аккаунт разблокирован. Подтвердите свой аккаунт с помощью метода безопасности, чтобы продолжить.',
      'oie.password.challenge.title': 'Подтверждение с помощью пароля',
      'oie.password.label': 'Пароль',
      'mfa.challenge.verify': 'подтвердить',
      'forgotpassword': 'Забыли пароль',
      'oie.email.challenge.mfa.title': 'Получить письмо для подтверждения',
      'oie.email.verify.subtitle.text.without.email': 'Отправьте письмо для подтверждения, нажав "Отправьте электронное письмо".',
      'oie.email.verify.primaryButton': 'Отправить электронное письмо',
      'oie.email.mfa.title': 'Подтверждение с помощью электронного письма',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'Мы отправили электронное письмо на адрес <$1>{0}</$1>.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Введите код подтверждения в текстовом поле.',
      'mfa.challenge.enterCode.placeholder': 'Введите код',
      'oie.select.authenticators.verify.title': 'Подтвердите, что это вы, с помощью метода безопасности',
      'oie.select.authenticators.verify.subtitle': 'Выберите один из следующих вариантов',
      'oie.email.label': 'Электронное письмо',
      'oie.verify.authenticator.button.text': 'Выбрать',
      'oie.phone.label': 'Звонок',
      'oie.phone.verify.sms.sendText.without.phone': 'Отправьте SMS с кодом на свой телефон',
      'oie.phone.carrier.charges': 'Оператор может взимать плату за отправку сообщений',
      'oie.phone.sms.primaryButton': 'Получить SMS с кодом',
      'oie.phone.call.secondaryButton': 'Позвонить',
      'oie.verification.switch.authenticator': 'Другой способ',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Мы отправили вам письмо с подтверждением.',
      'oie.email.verify.alternate.instructions': 'Нажмите на ссылку для подтверждения в письме, чтобы продолжить, или введите код ниже.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Введите код подтверждения',
      'oie.phone.verify.mfa.calling.without.phone': 'Звоним на ваш телефон. Введите код ниже для подтверждения.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Мы отправили код на ваш телефон. Введите код ниже для подтверждения.',
      'oie.password.reset.verification': 'Воспользуйтесь одним из следующих методов проверки, чтобы сбросить пароль.',
      'oie.phone.verify.title': 'Подтверждение с помощью звонка',
      'oie.phone.verify.sms.sendText': 'Отправьте SMS с кодом на',
      'oie.phone.alternate.title': 'ваш телефон',
      'mfa.calling': 'звоним',
      'oie.phone.verify.enterCodeText': 'Введите код ниже для подтверждения.',
      'oie.phone.verify.sms.codeSentText': 'Мы отправили код на'
    },
    'uk': {
      'primaryauth.title': 'Увійти',
      'primaryauth.username.placeholder': 'Ім’я користувача',
      'mfa.challenge.password.placeholder': 'Пароль',
      'oform.next': 'Далі',
      'unlockaccount': 'Розблокувати обліковий запис?',
      'help': 'Довідка',
      'password.reset.title.generic': 'Скидання пароля',
      'password.complexity.requirements.header': 'Вимоги до пароля: ',
      'password.complexity.length.description': 'Щонайменше {0} символів',
      'password.complexity.lowercase.description': 'Мала літера',
      'password.complexity.uppercase.description': 'Велика літера',
      'password.complexity.number.description': 'Число',
      'password.complexity.symbol.description': 'Символ',
      'password.complexity.no_username.description': 'Не має містити частину імені користувача',
      'password.complexity.no_first_name.description': 'Не має містити частини вашого імені',
      'password.complexity.no_last_name.description': 'Не має містити частину вашого прізвища',
      'password.complexity.history.description': 'Пароль не може збігатися з вашим останнім паролем',
      'oie.password.newPasswordLabel': 'Новий пароль',
      'oie.password.confirmPasswordLabel': 'Введіть пароль повторно',
      'password.reset.revokeSessions': 'Вийти із системи на всіх інших пристроях.',
      'password.reset': 'Скинути пароль',
      'goback': 'Назад до сторінки входу',
      'idx.return.link.otponly.your.verification.code': 'Ваш код підтвердження',
      'idx.enter.otp.in.original.tab': 'Введіть одноразовий пароль у початковому місці автентифікації.',
      'idx.return.link.otponly.warning.text': 'Якщо ви не запитували цей код, проігноруйте це повідомлення. Ваш обліковий запис у безпеці, доступ до нього можливий лише за допомогою цього коду.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Обліковий запис розблоковано. Підтвердьте свій обліковий запис за допомогою методу безпеки, щоб продовжити.',
      'oie.password.challenge.title': 'Підтвердження за допомогою пароля',
      'oie.password.label': 'Пароль',
      'mfa.challenge.verify': 'підтвердити',
      'forgotpassword': 'Забули пароль',
      'oie.email.challenge.mfa.title': 'Отримати електронний лист для підтвердження',
      'oie.email.verify.subtitle.text.without.email': 'Надішліть електронний лист для підтвердження, натиснувши "Надіслати мені електронний лист".',
      'oie.email.verify.primaryButton': 'Надіслати мені електронний лист',
      'oie.email.mfa.title': 'Підтвердження за допомогою електронного листа',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'Ми надіслали електронний лист на адресу <$1>{0}</$1>.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Введіть код підтвердження в текстове поле.',
      'mfa.challenge.enterCode.placeholder': 'Введіть код',
      'oie.select.authenticators.verify.title': 'Підтвердьте, що це ви, за допомогою методу безпеки',
      'oie.select.authenticators.verify.subtitle': 'Виберіть із наведених нижче варіантів',
      'oie.email.label': 'Електронний лист',
      'oie.verify.authenticator.button.text': 'Вибрати',
      'oie.phone.label': 'Дзвінок',
      'oie.phone.verify.sms.sendText.without.phone': 'Надішліть SMS із кодом на свій телефон',
      'oie.phone.carrier.charges': 'Оператор може стягувати плату за обмін повідомленнями',
      'oie.phone.sms.primaryButton': 'Отримати SMS із кодом',
      'oie.phone.call.secondaryButton': 'Зателефонувати',
      'oie.verification.switch.authenticator': 'Інший спосіб',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Ми надіслали вам електронний лист для підтвердження.',
      'oie.email.verify.alternate.instructions': 'Щоб продовжити, натисніть посилання для підтвердження в електронному листі або введіть код нижче.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Введіть код підтвердження',
      'oie.phone.verify.mfa.calling.without.phone': 'Телефонуємо на ваш телефон. Введіть код нижче для підтвердження.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Ми надіслали код на ваш телефон. Введіть код нижче для підтвердження.',
      'oie.password.reset.verification': 'Скористайтеся одним із наведених нижче методів перевірки, щоб скинути пароль.',
      'oie.phone.verify.title': 'Підтвердження за допомогою дзвінка',
      'oie.phone.verify.sms.sendText': 'Надішліть SMS із кодом на',
      'oie.phone.alternate.title': 'ваш телефон',
      'mfa.calling': 'телефонуємо',
      'oie.phone.verify.enterCodeText': 'Введіть код нижче для підтвердження.',
      'oie.phone.verify.sms.codeSentText': 'Ми надіслали код на'
    },
    'tr': {
      'primaryauth.title': 'Oturum Aç',
      'primaryauth.username.placeholder': 'Kullanıcı adı',
      'mfa.challenge.password.placeholder': 'Parola',
      'oform.next': 'Sonraki',
      'unlockaccount': 'Hesabın kilidi açılsın mı?',
      'help': 'Yardım',
      'password.reset.title.generic': 'Parolanızı sıfırlayın',
      'password.complexity.requirements.header': 'Parola gereksinimleri: ',
      'password.complexity.length.description': 'En az {0} karakter içermelidir',
      'password.complexity.lowercase.description': 'En az bir küçük harf içermelidir',
      'password.complexity.uppercase.description': 'En az bir büyük harf içermelidir',
      'password.complexity.number.description': 'En az bir sayı içermelidir',
      'password.complexity.symbol.description': 'En az bir özel karakter içermelidir',
      'password.complexity.no_username.description': 'Kullanıcı adının herhangi bir kısmını içermemelidir',
      'password.complexity.no_first_name.description': 'Adınızı içermemelidir',
      'password.complexity.no_last_name.description': 'Soyadınızı içermemelidir',
      'password.complexity.history.description': 'Parolanız, son parolanızla aynı olamaz',
      'oie.password.newPasswordLabel': 'Yeni parola',
      'oie.password.confirmPasswordLabel': 'Yeni parolayı tekrar girin',
      'password.reset.revokeSessions': 'Diğer tüm cihazlarda oturumumu kapat.',
      'password.reset': 'Parolayı Sıfırla',
      'goback': 'Oturum açmaya geri dön',
      'idx.return.link.otponly.your.verification.code': 'Doğrulama kodunuz',
      'idx.enter.otp.in.original.tab': "Orijinal kimlik doğrulama konumunuza OTP'yi girin.",
      'idx.return.link.otponly.warning.text': 'Bu kodu talep etmediyseniz bu mesajı görmezden gelebilirsiniz. Hesabınız güvendedir ve yalnızca bu kodla erişilebilir.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Hesap başarıyla açıldı! Devam etmek için hesabınızı bir güvenlik yöntemi ile doğrulayın.',
      'oie.password.challenge.title': 'Parolanızla doğrulayın',
      'oie.password.label': 'Parola',
      'mfa.challenge.verify': 'doğrula',
      'forgotpassword': 'Parolanızı mı unuttunuz?',
      'oie.email.challenge.mfa.title': 'Doğrulama e-postası alın',
      'oie.email.verify.subtitle.text.without.email': '"Bana bir e-posta gönder" seçeneğini tıklayarak bir doğrulama e-postası gönderin',
      'oie.email.verify.primaryButton': 'Bana bir e-posta gönder',
      'oie.email.mfa.title': 'E-postanızla doğrulayın',
      'oie.email.verify.alternate.magicLinkToEmailAddress': '<$1>{0}</$1> adresine bir e-posta gönderdik.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Doğrulama kodunu metin kutusuna girin.',
      'mfa.challenge.enterCode.placeholder': 'Kodu Girin',
      'oie.select.authenticators.verify.title': 'Bir güvenlik yöntemi ile siz olduğunuzu doğrulayın',
      'oie.select.authenticators.verify.subtitle': 'Aşağıdaki seçeneklerden birini belirleyin',
      'oie.email.label': 'E-posta',
      'oie.verify.authenticator.button.text': 'Seç',
      'oie.phone.label': 'Telefon',
      'oie.phone.verify.sms.sendText.without.phone': 'Telefonunuza SMS yoluyla bir kod gönderin',
      'oie.phone.carrier.charges': 'Operatör mesajlaşma ücretleri uygulanabilir',
      'oie.phone.sms.primaryButton': 'SMS yoluyla bir kod alın',
      'oie.phone.call.secondaryButton': 'Bunun yerine sesli arama alın',
      'oie.verification.switch.authenticator': 'Başka bir yöntemle doğrulayın',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Size bir doğrulama e-postası gönderdik.',
      'oie.email.verify.alternate.instructions': 'Devam etmek için e-postanızdaki doğrulama bağlantısına tıklayın veya kodu aşağıya girin.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Bunun yerine bir doğrulama kodu girin',
      'oie.phone.verify.mfa.calling.without.phone': 'Telefonunuz aranıyor. Doğrulamak için kodu aşağıya girin.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'Telefonunuza bir kod gönderildi. Doğrulamak için kodu aşağıya girin.',
      'oie.password.reset.verification': 'Parolanızı sıfırlamak için aşağıdaki güvenlik yöntemlerinden birini kullanarak doğrulama yapın.',
      'oie.phone.verify.title': 'Telefonunuzla doğrulayın',
      'oie.phone.verify.sms.sendText': 'SMS yoluyla şuraya bir kod gönderin: ',
      'oie.phone.alternate.title': 'telefonunuz',
      'mfa.calling': 'arama',
      'oie.phone.verify.enterCodeText': 'Doğrulamak için kodu aşağıya girin.',
      'oie.phone.verify.sms.codeSentText': 'Şuraya bir kod gönderildi: '
    },
    'ko': {
      'primaryauth.title': '로그인',
      'primaryauth.username.placeholder': '사용자 이름',
      'mfa.challenge.password.placeholder': '비밀번호',
      'oform.next': '다음',
      'unlockaccount': '계정을 잠금 해제하시겠습니까?',
      'help': '도움',
      'password.reset.title.generic': '비밀번호 재설정 완료',
      'password.complexity.requirements.header': '비밀번호 요구사항: ',
      'password.complexity.length.description': '최소한 {0}개의 문자를 포함해야 합니다',
      'password.complexity.lowercase.description': '하나 이상의 소문자를 포함해야 합니다',
      'password.complexity.uppercase.description': '하나 이상의 대문자를 포함해야 합니다',
      'password.complexity.number.description': '하나 이상의 숫자를 포함해야 합니다',
      'password.complexity.symbol.description': '하나 이상의 특수 문자를 포함해야 합니다',
      'password.complexity.no_username.description': '아이디의 일부를 포함해서는 안됩니다',
      'password.complexity.no_first_name.description': '이름의 일부를 포함해서는 안됩니다',
      'password.complexity.no_last_name.description': '성의 일부를 포함해서는 안됩니다',
      'password.complexity.history.description': '비밀번호는 이전 비밀번호와 같을 수 없습니다.',
      'oie.password.newPasswordLabel': '새 비밀번호',
      'oie.password.confirmPasswordLabel': '새 비밀번호 확인',
      'password.reset.revokeSessions': '다른 모든 기기에서 로그아웃해 주세요.',
      'password.reset': '비밀번호 재설정',
      'goback': '로그인으로 돌아가기',
      'idx.return.link.otponly.your.verification.code': '인증 코드',
      'idx.enter.otp.in.original.tab': '원래 인증 위치에 OTP를 입력하세요.',
      'idx.return.link.otponly.warning.text': '이 코드를 요청하지 않았다면 이 메시지를 무시해도 됩니다. 귀하의 계정은 안전하며 이 코드로만 액세스할 수 있습니다.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': '계정이 성공적으로 잠금 해제되었습니다! 계속하려면 보안 방법으로 계정을 확인하세요.',
      'oie.password.challenge.title': '비밀번호로 확인',
      'oie.password.label': '비밀번호',
      'mfa.challenge.verify': '확인하다',
      'forgotpassword': '비밀번호를 잊으셨나요?',
      'oie.email.challenge.mfa.title': '확인 이메일 받기',
      'oie.email.verify.subtitle.text.without.email': '이메일 보내기를 클릭하여 확인 이메일을 보내세요.',
      'oie.email.verify.primaryButton': '나에게 이메일을 보내기',
      'oie.email.mfa.title': '이메일로 확인',
      'oie.email.verify.alternate.magicLinkToEmailAddress': '<$1>{0}</$1>에게 이메일을 보냈습니다.',
      'oie.email.verify.alternate.verificationCode.instructions': '텍스트 상자에 인증코드를 입력하세요.',
      'mfa.challenge.enterCode.placeholder': '코드 입력',
      'oie.select.authenticators.verify.title': '보안 방법으로 본인 확인',
      'oie.select.authenticators.verify.subtitle': '다음 옵션 중에서 선택',
      'oie.email.label': '이메일',
      'oie.verify.authenticator.button.text': '선택',
      'oie.phone.label': '휴대전화 ',
      'oie.phone.verify.sms.sendText.without.phone': 'SMS를 통해 휴대전화로 코드를 전송',
      'oie.phone.carrier.charges': '통신사 메시지 요금이 부과될 수 있습니다.',
      'oie.phone.sms.primaryButton': 'SMS로 코드 받기',
      'oie.phone.call.secondaryButton': '대신 음성 통화 받기',
      'oie.verification.switch.authenticator': '기타 인증',
      'oie.email.verify.alternate.magicLinkToYourEmail': '확인 이메일을 보냈습니다.',
      'oie.email.verify.alternate.instructions': '계속하려면 이메일의 확인 링크를 클릭하거나 아래 코드를 입력하세요.',
      'oie.email.verify.alternate.show.verificationCode.text': '대신 확인 코드를 입력',
      'oie.phone.verify.mfa.calling.without.phone': '전화를 거는 중입니다. 아래 코드를 입력하여 확인하세요.',
      'oie.phone.verify.sms.codeSentText.without.phone': '휴대전화로 코드가 전송되었습니다. 아래 코드를 입력하여 확인하세요.',
      'oie.password.reset.verification': '비밀번호를 재설정하려면 다음 보안 방법 중 하나를 사용하여 인증하세요.',
      'oie.phone.verify.title': '휴대전화로 인증',
      'oie.phone.verify.sms.sendText': 'SMS를 통해 코드를 다음으로 전송합니다.',
      'oie.phone.alternate.title': '휴대전화',
      'mfa.calling': '통화',
      'oie.phone.verify.enterCodeText': '아래 코드를 입력하여 인증하세요.',
      'oie.phone.verify.sms.codeSentText': '다음으로 코드가 전송되었습니다.'
    },
    'zh-CN': {
      'primaryauth.title': '登录',
      'primaryauth.username.placeholder': '用户名',
      'mfa.challenge.password.placeholder': '密码',
      'oform.next': '下一步',
      'unlockaccount': '解锁账户？',
      'help': '帮助',
      'password.reset.title.generic': '重置密码',
      'password.complexity.requirements.header': '密码要求：',
      'password.complexity.length.description': '至少{0}个字符',
      'password.complexity.lowercase.description': '包含至少一个小写字母',
      'password.complexity.uppercase.description': '包含至少一个大写字母',
      'password.complexity.number.description': '包含至少一个数字',
      'password.complexity.symbol.description': '包含至少一个特殊字符',
      'password.complexity.no_username.description': '不包含用户名的任意部分',
      'password.complexity.no_first_name.description': '不包含您的名字',
      'password.complexity.no_last_name.description': '不包含您的姓氏',
      'password.complexity.history.description': '密码不得与您上次使用的密码相同',
      'oie.password.newPasswordLabel': '新密码',
      'oie.password.confirmPasswordLabel': '再次输入新密码',
      'password.reset.revokeSessions': '退出所有其他设备。',
      'password.reset': '重置密码',
      'goback': '返回登录页',
      'idx.return.link.otponly.your.verification.code': '您的验证码',
      'idx.enter.otp.in.original.tab': '在原始身份验证位置输入OTP。',
      'idx.return.link.otponly.warning.text': '如果您未请求此代码，则可忽略此消息。您的账户是安全的，只有使用此代码才能访问。',
      'oie.selfservice.unlock_user.landing.to.app.success.message': '账户解锁成功！使用安全方法验证您的账户以继续。',
      'oie.password.challenge.title': '使用密码验证',
      'oie.password.label': '密码',
      'mfa.challenge.verify': '验证',
      'forgotpassword': '忘记密码',
      'oie.email.challenge.mfa.title': '获取验证电子邮件',
      'oie.email.verify.subtitle.text.without.email': '单击“给我发送电子邮件”发送验证电子邮件',
      'oie.email.verify.primaryButton': '给我发送电子邮件',
      'oie.email.mfa.title': '使用您的电子邮件验证',
      'oie.email.verify.alternate.magicLinkToEmailAddress': '我们向<$1>{0}</$1>发送了一封电子邮件。',
      'oie.email.verify.alternate.verificationCode.instructions': '在文本框中输入验证码。',
      'mfa.challenge.enterCode.placeholder': '输入代码',
      'oie.select.authenticators.verify.title': '使用安全方法验证您的身份',
      'oie.select.authenticators.verify.subtitle': '从以下选项中选择',
      'oie.email.label': '电子邮件',
      'oie.verify.authenticator.button.text': '选择',
      'oie.phone.label': '电话',
      'oie.phone.verify.sms.sendText.without.phone': '通过短信将代码发送至您的手机',
      'oie.phone.carrier.charges': '运营商可能会收取短信费用',
      'oie.phone.sms.primaryButton': '通过短信接收代码',
      'oie.phone.call.secondaryButton': '改为接听语音电话',
      'oie.verification.switch.authenticator': '使用其他方式验证',
      'oie.email.verify.alternate.magicLinkToYourEmail': '我们向您发送了一封验证电子邮件。',
      'oie.email.verify.alternate.instructions': '单击电子邮件中的验证链接以继续或输入下方代码。',
      'oie.email.verify.alternate.show.verificationCode.text': '改为输入验证码',
      'oie.phone.verify.mfa.calling.without.phone': '正在拨打您的电话。输入下方代码进行验证。',
      'oie.phone.verify.sms.codeSentText.without.phone': '代码已发送至您的手机。输入下方代码进行验证。',
      'oie.password.reset.verification': '使用以下任意一种安全方法进行验证，以重置您的密码。',
      'oie.phone.verify.title': '用手机验证',
      'oie.phone.verify.sms.sendText': '通过短信将代码发送至',
      'oie.phone.alternate.title': '您的手机',
      'mfa.calling': '正在拨打电话',
      'oie.phone.verify.enterCodeText': '输入下方代码进行验证。',
      'oie.phone.verify.sms.codeSentText': '代码已发送至'
    },
    'zh-TW': {
      'primaryauth.title': 'Вход',
      'primaryauth.username.placeholder': 'Потребителско име',
      'mfa.challenge.password.placeholder': 'Парола',
      'oform.next': 'Следваща стъпка',
      'unlockaccount': 'Искаш ли да отключиш акаунта си?',
      'help': 'Помощ',
      'password.reset.title.generic': 'Нулирай паролата си',
      'password.complexity.requirements.header': 'Изисквания за паролата: ',
      'password.complexity.length.description': 'Трябва да съдържа поне {0} знака',
      'password.complexity.lowercase.description': 'Трябва да съдържа поне една малка буква',
      'password.complexity.uppercase.description': 'Трябва да съдържа поне една главна буква',
      'password.complexity.number.description': 'Трябва да съдържа поне един номер',
      'password.complexity.symbol.description': 'Трябва да съдържа поне един специален знак',
      'password.complexity.no_username.description': 'Не трябва да съдържа част от потребителското ти име',
      'password.complexity.no_first_name.description': 'Не трябва да съдържа част от името ти',
      'password.complexity.no_last_name.description': 'Не трябва да съдържа част от фамилията ти',
      'password.complexity.history.description': 'Паролата не може да бъде същата като последната ти парола',
      'oie.password.newPasswordLabel': 'нова парола',
      'oie.password.confirmPasswordLabel': 'Повтори новата парола',
      'password.reset.revokeSessions': 'Премахни регистрацията ми от всички други устройства.',
      'password.reset': 'Нулиране на парола',
      'goback': 'Назад към Вход',
      'idx.return.link.otponly.your.verification.code': 'Твоят код за потвърждение',
      'idx.enter.otp.in.original.tab': 'Въведи OTP в първоначалното си местоположение за удостоверяване.',
      'idx.return.link.otponly.warning.text': 'Ако не си поискал този код, можеш да игнорираш това съобщение. Твоят акаунт е безопасен и се влиза в него само с този код.',
      'oie.selfservice.unlock_user.landing.to.app.success.message': 'Акаунтът е отключен успешно! Потвърди акаунта си с метод за сигурност, за да продължиш.',
      'oie.password.challenge.title': 'Потвърди с паролата си',
      'oie.password.label': 'Парола',
      'mfa.challenge.verify': 'потвърди',
      'forgotpassword': 'Забравена парола',
      'oie.email.challenge.mfa.title': 'Получи имейл за потвърждение',
      'oie.email.verify.subtitle.text.without.email': 'Изпрати имейл за потвърждение, като кликнеш върху "Изпрати ми имейл".',
      'oie.email.verify.primaryButton': 'Изпрати ми имейл',
      'oie.email.mfa.title': 'Потвърди със своя имейл',
      'oie.email.verify.alternate.magicLinkToEmailAddress': 'Изпратихме имейл до <$1>{0}</$1>.',
      'oie.email.verify.alternate.verificationCode.instructions': 'Въведи кода за потвърждение в текстовото поле.',
      'mfa.challenge.enterCode.placeholder': 'Въведи код',
      'oie.select.authenticators.verify.title': 'Потвърди, че това си ти ​​с метод за сигурност',
      'oie.select.authenticators.verify.subtitle': 'Избери от следните опции',
      'oie.email.label': 'Имейл',
      'oie.verify.authenticator.button.text': 'Избор',
      'oie.phone.label': 'Телефон',
      'oie.phone.verify.sms.sendText.without.phone': 'Изпрати код чрез SMS на своя телефон',
      'oie.phone.carrier.charges': 'Операторът може да таксува съобщенията',
      'oie.phone.sms.primaryButton': 'Получаване на код чрез SMS',
      'oie.phone.call.secondaryButton': 'Вместо това приеми гласово повикване',
      'oie.verification.switch.authenticator': 'Потвърди по друг начин',
      'oie.email.verify.alternate.magicLinkToYourEmail': 'Изпратихме ти имейл за потвърждение.',
      'oie.email.verify.alternate.instructions': 'Кликни върху връзката за потвърждение в получения имейл, за да продължиш или въведи кода по-долу.',
      'oie.email.verify.alternate.show.verificationCode.text': 'Вместо това въведи код за потвърждение',
      'oie.phone.verify.mfa.calling.without.phone': 'Обаждане на телефона ти. Въведи кода по-долу, за да потвърдиш.',
      'oie.phone.verify.sms.codeSentText.without.phone': 'На твоя телефон беше изпратен код. Въведи кода по-долу, за да потвърдиш.',
      'oie.password.reset.verification': 'Потвърди с един от следните методи за сигурност, за да нулираш паролата си.',
      'oie.phone.verify.title': 'Потвърди с телефона си',
      'oie.phone.verify.sms.sendText': 'Изпрати код чрез SMS на',
      'oie.phone.alternate.title': 'своя телефон',
      'mfa.calling': 'обаждане',
      'oie.phone.verify.enterCodeText': 'Въведи кода по-долу, за да потвърдиш.',
      'oie.phone.verify.sms.codeSentText': 'Беше изпратен код до'
    }
  };
export default i18nConfig;




// WEBPACK FOOTER //
// ./src/helpers/i18nConfig.js